import {useState} from "react";
import {Button, Grid, Select} from "@mui/material";
import {FormattedMessage, defineMessage} from "react-intl";
import {showNotification} from "../../../actions";
import {useDispatch} from "react-redux";
import {useAssignableExtensionsQuery, useAssignExtensionMutation} from "../queries.generated";

type Props = {
    locationId: number;
    onSuccess: () => void;
};

// TODO: make this disabled if has no "edit_location" permission
export default ({locationId, onSuccess}: Props) => {
    const [extensionId, setExtensionId] = useState(0);
    const [options, setOptions] = useState([]);
    const [mutate] = useAssignExtensionMutation();
    const dispatch = useDispatch();

    const query = useAssignableExtensionsQuery({
        variables: {locationId},
    });

    async function submit() {
        if (extensionId === 0) return;

        const response = await mutate({variables: {locationId, userId: extensionId}});

        if (response.data.assignUser.length) {
            dispatch(
                showNotification(defineMessage({id: "unexpected_error", defaultMessage: "Unexpected error"}), "error"),
            );
            close();
            return;
        }

        dispatch(showNotification(defineMessage({id: "extension_added", defaultMessage: "User added"}), "success"));
        onSuccess();
        await reloadOptions();
        close();
    }

    if (query.data && query.data.assignableUsers.length && !options.length) {
        loadOptions();
    }

    async function reloadOptions() {
        const response = await query.refetch();
        loadOptions(response.data.assignableUsers);
    }

    function loadOptions(data?: any) {
        const extensions = data ? data : query.data.assignableUsers;
        const _options = [];
        for (const extension of extensions) {
            _options.push(
                <option key={extension.id} value={extension.id}>
                    {extension.shortNumber}
                </option>,
            );
        }
        setOptions(_options);
        setExtensionId(extensions[0].id);
    }

    return (
        <Grid container>
            <Grid container>
                <Grid>
                    <Select
                        variant="standard"
                        native
                        value={extensionId}
                        onChange={(event) => {
                            setExtensionId(Number(event.target.value));
                        }}
                    >
                        {options}
                    </Select>
                </Grid>
                <Grid>
                    <Button
                        style={{marginLeft: "1rem"}}
                        color="primary"
                        variant="contained"
                        size="small"
                        onClick={submit}
                    >
                        <FormattedMessage id="add_extension" defaultMessage="Add user" />
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
};
